import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';

export const AddEditPaymentConfigForm = (strings: any, organizations: [], paymentProviders: []): FormModel[] => {
  return [
    {
      label: strings.payment_config_column_hotel_Name,
      value: '',
      type: 'drop-down',
      placeholder: '',
      field: 'organizationId',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: organizations,
    },
    {
      label: strings.payment_config_column_merchant_id,
      value: '',
      typeValue: 'number',
      type: 'text',
      placeholder: '',
      field: 'merchantId',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_password,
      value: '',
      typeValue: 'password',
      type: 'text',
      placeholder: '',
      field: 'merchantPassword',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_secret,
      value: '',
      typeValue: 'password',
      type: 'text',
      placeholder: '',
      field: 'merchantSecret',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_username,
      value: '',
      typeValue: 'text',
      type: 'text',
      placeholder: '',
      field: 'merchantUserName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_payment_provider,
      value: '',
      type: 'drop-down',
      placeholder: '',
      field: 'paymentProvider',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: paymentProviders,
    },
    // {
    //   label: strings.payment_config_column_merchant_transaction_currency,
    //
    //   value: '',
    //   type: "drop-down",
    //   placeholder: '',
    //   field: 'transactionCurrency',
    //   validators: [],
    //   required: true,
    //   responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    // },
    {
      label: strings.payment_config_column_merchant_transaction_currency,
      value: '',
      typeValue: 'text',
      type: 'text',
      placeholder: '',
      field: 'transactionCurrency',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 5 }],
      required: false,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_transaction_iso_currency,
      value: '',
      typeValue: 'text',
      type: 'text',
      placeholder: '',
      field: 'transactionIsoCurrency',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 5 }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_Transaction_wallet,
      value: '',
      type: 'text',
      typeValue: 'number',
      placeholder: '',
      field: 'transactionWallet',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 2 }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_Sub_Account_Id,
      value: '',
      typeValue: 'text',
      type: 'text',
      placeholder: '',
      field: 'subAccountId',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_RedirectUrl,
      value: '',
      typeValue: 'text',
      type: 'text',
      placeholder: '',
      field: 'redirectUrl',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString },
        { check: Validators.ValidateUrl },
      ],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_merchant_CancelUrl,
      value: '',
      typeValue: 'text',
      type: 'text',
      placeholder: '',
      field: 'cancelUrl',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString },
        { check: Validators.ValidateUrl },
      ],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      label: strings.payment_config_column_default_payment_gateway,
      value: false,
      type: 'checkbox',
      field: 'defaultPaymentGateway',
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      placeholder: '',
      validators: [],
      required: false,
    },
  ];
};
